// AWS image bucket
export const imageAWSlink = 'https://portfolio--api.s3-us-west-1.amazonaws.com';

// API Portfolio Service
export const portfolioAPI = 'https://portfolio-api.com/json';
export const apiKey = 'lSNFA7gewSk96hCZ9tGplIwf';
